import {
  ParagraphArticleHighlights,
  ParagraphArticlesFiltered,
  ParagraphArticlesOverview,
  ParagraphCTA,
  ParagraphDownloads,
  ParagraphEventsFiltered,
  ParagraphEventsUpcoming,
  ParagraphExpertisesOverview,
  ParagraphFAQ,
  ParagraphLinkList,
  ParagraphLocationsMap,
  ParagraphMediaFiltered,
  ParagraphMetricItem,
  ParagraphMetrics,
  ParagraphPartnersHighlighted,
  ParagraphPartnersOverview,
  ParagraphPersons,
  ParagraphPersonsFiltered,
  ParagraphProjectsFiltered,
  ParagraphProjectsHighlighted,
  ParagraphProjectsOverview,
  ParagraphProjectTypesOverview,
  ParagraphQuote,
  ParagraphTechnologiesOverview,
  ParagraphText,
  ParagraphTextImageGrid,
  ParagraphTextMedia,
  ParagraphThemesOverview,
  ParagraphUSP,
  ParagraphUSPSubparagraph,
  ParagraphVacanciesMap,
  ParagraphVacanciesOverview,
  ParagraphWebform,
  ParagraphWorkingOnNow,
  ParagraphTimeline,
  ParagraphTimelineItem,
} from '../implementations';

const mappers = {
  article_highlights: ParagraphArticleHighlights,
  article_overview: ParagraphArticlesOverview,
  articles_filtered: ParagraphArticlesFiltered,
  cta_wrapper: ParagraphCTA,
  cta: ParagraphCTA,
  downloads: ParagraphDownloads,
  events_filtered: ParagraphEventsFiltered,
  faq: ParagraphFAQ,
  link_list: ParagraphLinkList,
  locations_map: ParagraphLocationsMap,
  media_filtered: ParagraphMediaFiltered,
  metric_item: ParagraphMetricItem,
  metrics: ParagraphMetrics,
  partners_highlighted: ParagraphPartnersHighlighted,
  partners_overview: ParagraphPartnersOverview,
  persons_filtered: ParagraphPersonsFiltered,
  persons: ParagraphPersons,
  project_types_overview: ParagraphProjectTypesOverview,
  projects_filtered: ParagraphProjectsFiltered,
  projects_highlighted: ParagraphProjectsHighlighted,
  projects_overview: ParagraphProjectsOverview,
  expertises_overview: ParagraphExpertisesOverview,
  technologies_overview: ParagraphTechnologiesOverview,
  quote: ParagraphQuote,
  text_image_grid: ParagraphTextImageGrid,
  text_media: ParagraphTextMedia,
  text: ParagraphText,
  themes_overview: ParagraphThemesOverview,
  upcoming_events: ParagraphEventsUpcoming,
  usp_subparagraph: ParagraphUSPSubparagraph,
  usp: ParagraphUSP,
  vacancies_map: ParagraphVacanciesMap,
  vacancies_overview: ParagraphVacanciesOverview,
  webform_wrapper: ParagraphWebform,
  working_on_now: ParagraphWorkingOnNow,
  timeline: ParagraphTimeline,
  timeline_item: ParagraphTimelineItem,
};

export default mappers;
